import { useCallback, useState } from 'react';
import { JFormik } from '@centerpiece/components';
import * as Yup from 'yup';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  useGetItemStatusesQuery,
  useDeleteItemStatusMutation,
  useUpdateItemStatusMutation,
  useCreateItemStatusMutation,
} from 'store/api';

export const ItemStatusesTab = () => {
  const [editing /*, setEditing*/] = useState<boolean>(false);
  const { data: statuses = [], isLoading } = useGetItemStatusesQuery({});
  const [createItemStatus] = useCreateItemStatusMutation();
  const [editItemStatus] = useUpdateItemStatusMutation();
  const [deleteItemStatus] = useDeleteItemStatusMutation();
  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <JFormik
      initialValues={useCallback(() => ({ statuses: statuses }), [statuses])}
      handleSubmit={async (values, formik) => {}}
      loading={isLoading}
      validationSchema={
        editing
          ? Yup.object({
              name: Yup.string().required('Name is required'),
            })
          : Yup.object({})
      }
      disabled={!editing}
      form={[
        {
          name: 'statuses',
          itemType: 'table_array',
          label: 'Item Statuses',
          tableProps: {
            onCreate: (values: any) => createItemStatus(values),
            onEdit: (values: any) => editItemStatus(values),
            onDelete: (id: number) => deleteItemStatus(id),
            readOnly: (values: any) =>
              values?.subscription === undefined && values?.id > 0,
            // headers: [
            //   {
            //     name: 'name',
            //     label: 'Status *',
            //     itemType: 'textfield',
            //     jItemProps: {
            //       width: '100%',
            //       sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
            //     },
            //     gridProps: { xs: 12 },
            //   },
            // ],
            columns: [
              {
                name: 'name',
                label: 'Status *',
                itemType: 'textfield',
                jItemProps: {
                  width: '100%',
                  sx: { boxSizing: 'border-box', px: { xs: 0.5 } },
                },
                gridProps: { xs: 12 },
              },
            ],
          },
          device: downSm ? 'mobile' : 'desktop',
        },
      ]}
    />
  );
};
